import { useLocation } from 'react-router'
import React from 'react'

export function useQuery (param: string): string | undefined {
  const { search } = useLocation()

  return React.useMemo(() => new URLSearchParams(search), [search]).get(param)
}
